<template>
  <div style="height: 70vh; overflow: scroll">
    <div class="tabs-wrap">
      <div :class="['tab-item', 0 === active ? 'active' : '']" @click="changeTab(0)">小结内容</div>
      <div
        :class="['tab-item', 1 === active ? 'active' : '']"
        @click="changeTab(1)"
        v-if="summaryInfo.msgIdList && summaryInfo.msgIdList.length"
      >
        聊天记录
      </div>
      <div
        v-if="summaryInfo.cdrId"
        :class="['tab-item', 2 === active ? 'active' : '']"
        @click="changeTab(2)"
      >
        通话记录
      </div>
      <div :class="['tab-item', 3 === active ? 'active' : '']" @click="changeTab(3)">操作记录</div>
    </div>
    <div class="summary-content" v-if="active === 0">
      <a-spin :spinning="loading">
        <div class="summary-info">
          <span>添加人：{{ summaryInfo.createByName }}</span>
          <span>添加时间：{{ summaryInfo.createdAt }}</span>
        </div>
        <div class="user-info-wrap">
          <div class="line">
            <div class="user-info-item">
              <span>患者姓名：</span>
              {{ summaryInfo?.patientProfileCommonVO?.patientProfileName || '--' }}
            </div>
            <div class="user-info-item">
              <span>性别：</span>
              {{ getProfileByKey(summaryInfo?.patientProfileCommonVO, 'gender') || '--' }}
            </div>
            <div class="user-info-item">
              <span>年龄：</span>
              {{ getProfileByKey(summaryInfo?.patientProfileCommonVO, 'age') || '--' }}
            </div>
          </div>
          <div class="line">
            <div class="user-info-item">
              <span>医生姓名：</span>
              {{ summaryInfo.doctorName }}
            </div>
          </div>
          <div class="line">
            <div class="user-info-item">
              <span>小结来源：</span>
              {{ SOURCE_TYPE[summaryInfo?.source] || '--' }}
              <span v-if="summaryInfo?.isAiCallOut && summaryInfo?.aiCallTypeStr" class="tips">
                ({{ summaryInfo?.aiCallTypeStr }})
              </span>
            </div>
            <div v-if="![12, 13].includes(summaryInfo.type)" class="user-info-item">
              <span>关联处方：</span>
              <template v-if="summaryInfo.parentSns">
                <a-button
                  v-for="item in summaryInfo.parentSns"
                  :key="item"
                  @click="openDetail(item)"
                  type="link"
                  size="small"
                >
                  处方详情
                </a-button>
              </template>
              <span v-else>--</span>
            </div>
          </div>
        </div>
        <!-- 小结内容 -->
        <div class="form-title">
          小结内容
          <div v-if="summaryInfo.cdrId" class="span">电话沟通</div>
          <div v-if="isAI" class="ai-tag">内容由AI生成</div>
        </div>
        <div v-if="summaryInfo.type === 1" class="contentsJson">
          <div v-for="(item, index) in GuideLablesConfigNoImg" :key="index">
            <span>{{ item.label }}：</span>
            <span>{{ jsonContents[item.key] || '--' }}</span>
          </div>
        </div>
        <a-textarea
          v-else
          class="search-input textarea"
          :maxlength="500"
          disabled
          :value="summaryInfo.contents"
        ></a-textarea>
        <!-- 未购买原因 -->
        <div v-if="![12, 13].includes(summaryInfo.type)" class="not-purchased-reason">
          <div class="title">未购买原因：</div>
          <div class="content">
            <template v-if="summaryInfo?.callChatSummary?.notBuyReasonType === 5">
              其他原因： {{ summaryInfo?.callChatSummary?.notBuyOtherReason || '暂无' }}
            </template>
            <template v-else>
              {{ summaryInfo?.callChatSummary?.notBuyReason || '--' }}
            </template>
          </div>
        </div>
        <div class="form-title" style="margin-top: 20px" v-if="summaryInfo.type === 1">
          疾病相关图片资料
        </div>
        <div class="upload-Wrap" v-if="summaryInfo.type === 1">
          <a-image-preview-group v-if="fileList && fileList.length">
            <auth-img
              mode="ant"
              v-for="(img, index) in fileList || []"
              :key="index"
              :src="img.filePath"
              :width="100"
              :height="100"
              class="aImgs"
            />
          </a-image-preview-group>
          <span v-else>无</span>
        </div>
      </a-spin>
      <!-- ai 小结有这个 -->
      <template v-if="hasAITag">
        <div class="AI-info">
          <header class="header">
            <h5 class="title">目标事项</h5>
            <div class="tips">{{ AItitle }}</div>
          </header>
          <AIPrescription v-if="summaryInfo.type === 2" :parentSns="parentSns"></AIPrescription>
          <!-- 12-疗效跟踪、13-疗效反馈不展示 -->
          <AIReservation
            v-else-if="![12, 13].includes(summaryInfo.type)"
            :cureReserveId="summaryInfo.cureReserveId"
          ></AIReservation>
        </div>
        <div class="AI-info" v-if="![12, 13].includes(summaryInfo.type)">
          <header class="header">
            <div class="tips">AI处理流</div>
          </header>
          <AIRecord :workOrderId="workOrderId" :hasDrawer="false" ref="AIRecordRef" />
        </div>
      </template>
      <!-- 虚拟电话来源-其他补充 -->
      <div
        v-if="summaryInfo?.type == 10 && summaryInfo?.callChatSummary?.source === 10"
        class="others"
      >
        <div class="title">其他补充</div>
        <div class="diagnoses">
          <span class="label label-pad">诊断：</span>
          <span class="text">{{ summaryInfo?.diagnoses || '--' }}</span>
        </div>
        <div>
          <div class="medical label-pad">病情补充：</div>
          <a-textarea
            class="search-input textarea"
            :maxlength="200"
            disabled
            :value="summaryInfo?.callChatSummary?.medicalConditionContent"
          ></a-textarea>
        </div>
        <div>
          <div class="medical label-pad">治疗情况：</div>
          <a-textarea
            class="search-input textarea"
            :maxlength="200"
            disabled
            :value="summaryInfo?.callChatSummary?.treatmentContent"
          ></a-textarea>
        </div>
      </div>
    </div>
    <Chat
      v-else-if="active === 1"
      style="height: calc(100% - 36px)"
      :customList="msgList"
      :showTabs="false"
      :showLoadMore="false"
      :groupId="summaryInfo.groupId"
      :msgTimeRange="msgTimeRange"
    />
    <CallLog
      :cdrId="summaryInfo.cdrId"
      :cdrIdArr="summaryInfo?.cdrIds || []"
      :patientName="summaryInfo.patientName"
      :showOption="false"
      v-else-if="active === 2"
      @closeSummaryModal="closeSummaryModal"
    />
    <a-table
      class="table-wrap"
      v-else
      :loading="loading"
      :pagination="data.pagination"
      rowKey="id"
      :columns="SummaryLogColumns"
      :data-source="data.table"
      show-quick-jumper
      @showSizeChange="onPageOrSize"
      @change="onPageOrSize"
      :scroll="{ x: '100%', y: '456px' }"
    >
      <template #contents="{ text: contents }">
        <a-tooltip color="#fff" overlayClassName="aaaaa" placement="bottomLeft">
          <template #title>
            <span :style="{ fontSize: '14px', color: '#333333' }">
              {{ contents }}
            </span>
          </template>
          <div class="contents">{{ contents }}</div>
        </a-tooltip>
      </template>
    </a-table>
    <!-- 处方详情 -->
    <the-detail
      v-model:visible="PrescriptionDetails.visible"
      :serialNumber="PrescriptionDetails.serialNumber"
      :recordType="PrescriptionDetails.recordType"
    />
  </div>
</template>
<script setup>
import TheDetail from '@/components/TheDetail/index.vue'
import { defineProps, reactive, ref, onMounted, computed, defineEmits, nextTick } from 'vue'
import { SummaryLogColumns, TYPE, SOURCE_TYPE } from '@/constants/columns'
import {
  getSummaryInfo,
  getSummaryLog,
  getChatRecord
  // getChatSummaryById
} from '@/api/workPlace/summary'
// import Config from '@/config/index'
import Chat from '../../history.vue'
import CallLog from '../../../CallLog/index.vue'
import { GuideLablesConfigNoImg } from '@/views/WorkPlace/Container/chat/components/message/config.js'
import AIPrescription from './AIPrescription.vue'
import AIReservation from './AIReservation.vue'
import {
  AI_TYPE
  //  SOURCE
} from './config'
import AIRecord from '../AIRecord/index.vue'
import { getProfileByKey } from '@/utils/index.js'

const loading = ref(false)
const AIRecordRef = ref(null)
const emits = defineEmits(['closeSummaryModal'])
const props = defineProps({
  chatSummaryId: {
    type: String,
    required: true
  },
  origin: {
    type: String,
    default: ''
  },
  active: {
    type: Number,
    default: 0
  }
})
const closeSummaryModal = () => {
  emits('closeSummaryModal')
}
const active = ref(0)
const summaryInfo = ref({})
const workOrderId = computed(() => {
  let workOrderId = ''
  if (summaryInfo.value.workOrderIds) {
    workOrderId = summaryInfo.value.workOrderIds[0]
  }
  return workOrderId
})
const parentSns = ref([])
// 是否需要 AI 目标事项
const hasAITag = ref(false)
// 是否 AI 类型
const isAI = computed(() => {
  const is = AI_TYPE.some(v => v.value === summaryInfo.value.type)
  return is
})
const changeTab = index => {
  active.value = index
  nextTick(() => {
    if (isAI.value && index === 0 && AIRecordRef.value) {
      AIRecordRef.value.showDrawer()
    }
  })
}
const msgList = ref([])
onMounted(() => {
  getDetail()
  getMsgList()
  summaryLog()
})

const jsonContents = ref({})
const getMsgList = () => {
  getChatRecord({ chatSummaryId: props.chatSummaryId }).then(res => {
    msgList.value = res
  })
}

const detaiLoading = ref(false)
const fileList = ref([])
const getDetail = () => {
  detaiLoading.value = true
  fileList.value = []
  parentSns.value = []
  getSummaryInfo({ chatSummaryId: props.chatSummaryId })
    .then(res => {
      summaryInfo.value = res || {}
      parentSns.value = res.parentSns
      // summaryInfo.value.source = TYPE[summaryInfo?.value.type]?.belong
      sourceMapFunc()
      if (res.type === 10) {
        summaryInfo.value.diagnoses = res?.callChatSummary?.diagnosesList
          ?.map(item => item.diagnosesContent)
          ?.join('；')
      }
      hasAITag.value = AI_TYPE
        // 过滤 3和6的类型
        .filter(v => ![3, 6].includes(v.value))
        .some(v => v.value === res.type)
      // console.log('res.contents', res.contents)
      if (res.type === 1) {
        jsonContents.value = JSON.parse(res.contents)
        console.log(jsonContents.value)
        const imageList = jsonContents.value.imageList || []
        fileList.value = imageList.map((it, index) => {
          return {
            filePath: it,
            fileName: 'img' + index
          }
        })
      }
      changeTab(props.active || 0)
      nextTick(() => {
        if (hasAITag.value) {
          AIRecordRef.value.showDrawer()
        }
      })
    })
    .finally(() => {
      detaiLoading.value = false
    })
}
const AItitle = computed(() => {
  const one = AI_TYPE.find(v => v.value === summaryInfo.value.type)
  if (one) {
    return one.title
  } else {
    return ''
  }
})
const msgTimeRange = computed(() => {
  const { chatRecordStartTime, chatRecordEndTime } = summaryInfo.value
  return chatRecordStartTime === chatRecordEndTime
    ? chatRecordStartTime
    : `${chatRecordStartTime} 至 ${chatRecordEndTime}`
})

const data = reactive({
  // 分页器
  pagination: {
    current: 1,
    pageSize: 10,
    showQuickJumper: true,
    showSizeChanger: true,
    total: 100
  },
  // 表格
  table: []
})
// 处方详情
const PrescriptionDetails = reactive({
  visible: false,
  serialNumber: '',
  recordType: 'prescriptionGroup'
})
// 待购工单AI语音优化
const openDetail = serialNumber => {
  PrescriptionDetails.visible = true
  PrescriptionDetails.serialNumber = serialNumber
}
// 获取病历数据
function summaryLog() {
  loading.value = true
  getSummaryLog({
    chatSummaryId: props.chatSummaryId,
    currPage: data.pagination.current,
    pageSize: data.pagination.pageSize
  })
    .then(res => {
      data.table = res.list
      data.pagination.total = res.totalCount
    })
    .finally(() => (loading.value = false))
}
//改变当前页 和 改变页码值
function onPageOrSize({ current = 1, pageSize = 10 }) {
  data.pagination.pageSize = pageSize
  data.pagination.current = current
  summaryLog()
}
// 对 type 进行映射 source
const sourceMapFunc = () => {
  const type = summaryInfo?.value.type
  // 兼容老业务，type 10 的时候，source 也是10的历史数据问题
  if (type === 10) {
    const source = summaryInfo.value.callChatSummary.source
    summaryInfo.value.source = source === 4 ? 4 : 3
  } else {
    summaryInfo.value.source = TYPE.find(item => item.value === type)?.belong
  }
}
</script>
<style lang="scss" scoped>
.tabs-wrap {
  display: flex;
  border-bottom: 1px solid rgba(0, 0, 0, 0.09);
  padding-left: 20px;
  .tab-item {
    cursor: pointer;
    width: 109px;
    height: 36px;
    background: #f4f4f4;
    border: 1px solid rgba(0, 0, 0, 0.09);
    border-bottom: none;
    border-radius: 4px 4px 0 0;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    text-align: center;
    line-height: 36px;
    margin-right: 12px;
    &.active {
      color: #1890ff;
      background: #fff;
    }
  }
}
.contents {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 12px;
  color: #333333;
  line-height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.summary-content {
  padding: 0 24px;
  .AI-info {
    margin: 20px 0;
    .header {
      .title {
        font-size: 16px;
        margin-bottom: 16px;
      }
      .tips {
        margin: 20px 0 10px;
        font-weight: 500;
        color: #333333;
        font-size: 14px;
      }
    }
  }
}
.form-title {
  font-family: PingFangSC-Medium;
  font-weight: bold;
  font-size: 16px;
  color: #333333;
  margin-bottom: 8px;
  .span {
    display: inline-block;
    font-size: 14px;
    color: #24bca2;
    margin-left: 8px;
    padding: 0px 4px;
    border: 1px solid #24bca280;
    border-radius: 4px;
    font-weight: normal;
  }
  .ai-tag {
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    display: inline-block;
    margin-left: 8px;
  }
}
.not-purchased-reason {
  font-weight: bold;
  color: #333333;
  margin-top: 16px;
  .title {
    font-size: 16px;
    margin-bottom: 8px;
  }
  .content {
    font-size: 14px;
  }
}
.upload-Wrap {
  display: flex;
  flex-wrap: wrap;
  ::v-deep(.ant-image) {
    margin-right: 10px;
    margin-bottom: 10px;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    display: flex;
    align-items: center;
    padding: 4px;
    overflow: hidden;
  }
}

.summary-info {
  padding-top: 16px;
  text-align: right;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  text-align: right;
  line-height: 24px;
  margin-bottom: 8px;
  span {
    margin-left: 60px;
  }
}
.user-info-wrap {
  padding-bottom: 12px;
  border-bottom: 1px solid #e8e8e8;
  margin-bottom: 16px;

  .line {
    display: flex;
    padding: 7px 0;

    .user-info-item {
      height: 30px;
      line-height: 30px;
      padding: 0 48px 0 16px;
      font-family: PingFangSC-Medium;
      font-weight: bold;
      font-size: 14px;
      color: #333333;
      border-right: 1px solid #e8e8e8;
      span {
        color: #999999;
      }
      &:first-child {
        padding-left: 0;
      }

      &:last-child {
        border-right: none;
      }
      .tips {
        font-weight: 500;
        font-size: 14px;
        color: #ff9412;
      }
    }
  }
}

.contentsJson {
  font-weight: bold;
  font-size: 14px;
  color: #333333;
  box-sizing: border-box;
  padding: 8px 12px;
  background: rgba(250, 250, 250, 0.5);
  border: 1px solid #d9d9d9;
  border-radius: 4px;
}

.search-input {
  font-family: PingFangSC-Medium;
  font-weight: bold;
  font-size: 14px;
  color: #333333;
  box-sizing: border-box;
  padding: 8px 12px;
  background: rgba(250, 250, 250, 0.5);
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  &.textarea {
    box-sizing: border-box;
    height: 200px;
    padding: 8px 12px;
    resize: none;
  }
  &:disabled {
    cursor: initial;
  }
}
::v-deep(.ant-form-item-label > label) {
  color: #333;
  font-size: 16px;
  font-weight: bold;
}
.table-wrap {
  margin: 20px 24px;
}

.others {
  margin: 20px 0;
  border-top: 1px solid #f0f0f0;
  .title {
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    padding: 20px 0;
  }
  .label-pad {
    padding: 12px 3px;
  }
  .diagnoses {
    font-size: 14px;
    font-weight: 500;
    .label {
      color: #999999;
    }
    .text {
      color: #333333;
    }
  }
  .medical {
    font-weight: 500;
    font-size: 14px;
    color: #333333;
  }
}
</style>
